//电子投保
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'
export default {
  // 电子投保
  '/sale/order/saveOrUpdateOrderInfo': mockBaseUrl + '/calculatePremium',
  '/sale/order/orderList': mockBaseUrl + '/sale/order/orderList',
  // 获取告知消息
  '/information': mockBaseUrl + '/information'
}
